var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool",on:{"click":function($event){return _vm.$router.push('/topup');}}},[_c('span',{staticClass:"num num-message"},[_vm._v(_vm._s(_vm.userInfo.message_limit > 99 ? '99+' : _vm.userInfo.message_limit || 0))]),_c('span',{staticClass:"num num-coin"},[_vm._v(_vm._s(_vm.userInfo.coin > 99 ? '99+' : _vm.userInfo.coin || 0))])])
}
var staticRenderFns = []

export { render, staticRenderFns }